module.exports = __webpack_public_path__ + "images/sprites/tax_icons-sb6839e3ed1_ca0265d8a66ee33513170359db90e38e.png";